import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomePlus"><Path fillRule="evenodd" clipRule="evenodd" d="M21 8.32715V21H3V8.32715L12 2.87305L21 8.32715ZM11.25 12.25H9V13.75H11.25V16H12.75V13.75H15V12.25H12.75V10H11.25V12.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomePlus;
